var map = {
	"./symbol_0.png": "9fae",
	"./symbol_1.png": "950b",
	"./symbol_10.png": "eff4",
	"./symbol_2.png": "e608",
	"./symbol_3.png": "6bb9",
	"./symbol_4.png": "4c40",
	"./symbol_5.png": "796e",
	"./symbol_6.png": "8a08",
	"./symbol_7.png": "5627",
	"./symbol_8.png": "5227",
	"./symbol_9.png": "3520"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2382";